module.exports = __webpack_public_path__ + "img/no-data-icon.45cc68e6.png";